import { observer } from "mobx-react";
import { IRmaAction, IRmaValidateAllAction } from "../../stores/rma-page-store";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
	validateAllAction: IRmaValidateAllAction;
	disabled: boolean;
	label: string;
	setCurrentRmaAction: (action: IRmaAction | null) => void;
	rmaId: number;
}

const RmaValidateAllToolbarButton: React.FC<IProps> = observer(
	({validateAllAction, disabled, label, setCurrentRmaAction, rmaId}) => {
		const onClick = () => {
			rmsMixpanelStore.trackEvent("d&_validate_all", { RMAID: rmaId });
			setCurrentRmaAction(validateAllAction);
		};

		return (
			<Button
				variant={BUTTON_VARIANTS.PrimaryAccent}
				text={label}
				disabled={validateAllAction.disabled || disabled}
				onClick={onClick}
			/>
		);
	}
);

export default RmaValidateAllToolbarButton;
